var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contract-file',{attrs:{"contract-id":_vm.contractId,"is-init":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }